import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'morva-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {
  @Input() tableItems = [];

  moreItems = [{ title: '2' }, { title: '3' }];

  checked = false;
  checkedItems = [];

  constructor(private router: Router) { }

  ngOnInit(): void { }

  selectRow(event, selectedItem) {
    if (event) {
      this.checkedItems.push(selectedItem);
    } else {
      this.checkedItems = this.checkedItems.filter(
        (item) => item.id !== selectedItem.id,
      );
    }
  }

  removeAll() {
    this.checkedItems = [];
  }

  isChecked(item) {
    return this.checkedItems.includes(item);
  }

  selectAll() {
    this.checkedItems = this.tableItems;
  }

  toggleSelection(event) {
    if (event) {
      this.selectAll();
    } else {
      this.removeAll();
    }
  }

  starIcon(isImported) {
    const icon = isImported ? 'star' : 'star-outline';
    return icon;
  }

  onStarClick(itemId) {
    var itemState = this.tableItems.find((item) => item.id === itemId).isStared;
    this.tableItems.find((item) => item.id === itemId).isStared = !itemState;
  }
}
